import { apiSlice } from '../../api/apiSlice';

export const teacherDocumentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentsBySetId: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.setId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateDescription: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.documentId}/description?setId=${option.setId}`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: {
          description: option.description
        }
      })
    }),
    deleteResource: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.documentId}/set/${option.setId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    updateDocumentScope: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.documentId}?scope=${option.isPublic}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    createTeacherDocument: builder.mutation({
      query: (teacherDocument) => ({
        url: 'TeacherDocument',
        method: 'POST',
        credentials: 'include',
        body: { ...teacherDocument }
      })
    }),
    updateDocumentUrl: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.documentId}/url`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: {
          url: option.url
        }
      })
    }),
    updateDocumentContent: builder.mutation({
      query: (option) => ({
        url: `TeacherDocument/${option.documentId}/content`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(option.content)
      })
    }),
    uploadDocument: builder.mutation({
      query: (fileData) => ({
        url: 'TeacherDocument/upload',
        method: 'POST',
        credentials: 'include',
        body: fileData
      })
    }),
    getImageCategories: builder.mutation({
      query: () => ({
        url: 'BrowseFile/Categories',
        method: 'GET'
      })
    }),
    getImages: builder.mutation({
      query: (option) => ({
        url: `BrowseFile/category/${option.categoryId}/Images?folderName=${option.folderName}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    uploadImages: builder.mutation({
      query: (files) => ({
        url: 'BrowseFile/Upload',
        method: 'POST',
        body: files
      }),
      extraOptions: { showGlobalError: true }
    }),
    checkImageExist: builder.mutation({
      query: (fileName) => ({
        url: `BrowseFile/ImageExist?fileName=${fileName}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    deleteImage: builder.mutation({
      query: (fileName) => ({
        url: `BrowseFile/images/${fileName}`,
        method: 'DELETE'
      }),
      extraOptions: { showGlobalError: true }
    })
  })
});

export const {
  useGetTeacherDocumentsMutation,
  useGetDocumentsBySetIdMutation,
  useUpdateDescriptionMutation,
  useDeleteResourceMutation,
  useUpdateDocumentScopeMutation,
  useCreateTeacherDocumentMutation,
  useUpdateDocumentUrlMutation,
  useUpdateDocumentContentMutation,
  useUploadDocumentMutation,
  useGetImageCategoriesMutation,
  useGetImagesMutation,
  useUploadImagesMutation,
  useCheckImageExistMutation,
  useDeleteImageMutation
} = teacherDocumentApi;